<template>
	<div class="grid grid-cols-2 gap-x-4 gap-y-8 lg:grid-cols-4">
		<sb-category-card
			v-for="category in categories"
			:key="category.id"
			:blok="category"
		/>

		<div class="col-span-full lg:hidden">
			<div class="mx-2 my-10 md:mx-8 md:mt-20 lg:mb-8">
				<v-button
					class="w-full font-bold md:text-xl md:leading-5"
					:aria-label="t('loader.show-more')"
					theme="black"
				>
					{{ $t("loader.show-more") }}
				</v-button>
			</div>

			<div>
				<div class="mx-2 mb-2 h-1 w-auto rounded bg-gray-300 md:mx-8">
					<div :style="progress" class="h-1 rounded bg-black"></div>
				</div>

				<p class="text-center font-sans text-base font-normal">
					{{ $t("loader.show-more-prefix") }} 24 / 299
					{{ $t("loader.show-more-suffix") }}
				</p>
			</div>

			<div class="flex justify-center">
				<v-button
					class="mt-16 mb-14 md:mt-14 md:mb-11"
					:aria-label="$t('loader.back-to-start')"
					@click="scrollToTop"
				>
					<p class="font-sans text-base tracking-xl normal-case underline">
						{{ $t("loader.back-to-start") }}
					</p>
				</v-button>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import type {ISbStoryData} from "storyblok-js-client";

import {useStoryblokStoriesList} from "@pkg/shared/composables/use-storyblok-stories-list";

const properties = defineProps<{
	blok: ISbStoryData[];
}>();

const categoryUuids = properties.blok.join(",");

const {t} = useI18n();

const scrollToTop = () => {
	window.scrollTo({top: 0, behavior: "smooth"});
};

const totalCategories = 300;

const showCategories = 150;

const progress = computed(() => {
	const width = (showCategories / totalCategories) * 100;
	return `width: ${width}%`;
});

const {
	data: {value: categories},
} = await useStoryblokStoriesList(`rooms-${categoryUuids}`, {
	starts_with: `${t("storyblok.rooms")}/`,
	by_uuids: categoryUuids,
});
</script>
